<template>
    <div class="newPage">
        <div class="breadcrumb">
            <breadcrumb></breadcrumb>
        </div>
        <div class="content">
            <div class="steps">
                <el-steps  :active="stepActive">
                    <el-step title="数据参数"></el-step>
                    <el-step title="文件上传"></el-step>
                    <el-step title="字段映射"></el-step>
<!--                    <el-step title="数据参数"></el-step>-->
                    <el-step title="数据导入"></el-step>
                </el-steps>
            </div>
            <div class="stepsContent">
                <div class="stepsItem" v-if="stepActive===0">
                  <div class="itemForm">
                      <div class="label">
                          上传的数据类型:
                      </div>
                      <div class="value">
                          <el-select v-model="stepsForm.mapperTable"
                                     @change="mapperTableChange"
                                     size="small" placeholder="请选择" value-key="mapperId">
                              <el-option v-for="item in typeList" :label="item.name" :value="item"
                                         :key="item.mapperId"></el-option>
                          </el-select>
                      </div>
                  </div>
                    <div class="itemForm">
                        <div class="label">
                            数据所属城市:
                        </div>
                        <div class="value">
                            <el-cascader
                                    v-model="stepsForm.citys"
                                    :options="cityList"
                                    :props="{
                                        multiple: false,
                                        label:'lable',
                                        value:'lable'
                                    }"
                                    size="small"
                                    clearable
                            ></el-cascader>
                        </div>
                    </div>
                    <div class="itemForm" v-if="stepsForm.mapperTable">
                        <div class="label">
                            数据单位:
                        </div>
                        <div class="value">
                            <el-select v-model="stepsForm.unit" size="small"
                                       :disabled="stepsForm.mapperTable.mapperId!==1"
                                       placeholder="请选择" value-key="mapperId">
                                <el-option label="ppb" value="ppb"></el-option>
                                <el-option label="ug/m3" value="ug/m3"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="stepsBtns">
                        <el-button type="primary" class="btn" size="small" @click="nextStep">下一步</el-button>
                    </div>
                </div>
                <div class="stepsItem" v-if="stepActive===1">
                    <div class="fileBox">
                        <div class="fileAdd">
                            <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    :action="uploadExcel"
                                    :headers="headers"
                                    :on-success="fileSuccess"
                                    :on-change="handleChange"
                                    :on-remove="handleRemove"
                                    accept=".xlsx"
                                    :limit="1"
                                    :on-exceed="handleExceed"
                                    :file-list="fileList"
                                    :auto-upload="false">
                                <el-button type="primary" class="btn" size="small">添加文件</el-button>

                                <div slot="tip" class="el-upload__tip">只能上传excel .xlsx文件,且文件只能包含一个城市</div>
                            </el-upload>
                        </div>
                    </div>
                    <div class="sheetBox">
                        <div class="sheetList" v-if="fileSheetList && fileSheetList.length">
                            <div class="sheetItem">
                                <el-checkbox-group v-model="selectSheet">
                                    <el-checkbox  v-for="item in fileSheetList"  :label="item" :value="item" :key="item">
                                    </el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </div>
                    <div class="stepsBtns">
                        <el-button class="btn" size="small" @click="prevStep">上一步</el-button>
                        <el-button type="primary" class="btn" size="small" @click="nextStep">下一步</el-button>
                    </div>
                </div>
                <div class="stepsItem" v-if="stepActive===2">
                    <div class="mapForm">
                        <div class="itemForm">
                            <div class="label">目标表：</div>
                            <div class="value" v-if="stepsForm.mapperTable">
                                <div>{{stepsForm.mapperTable.tableName}}</div>
                            </div>
                        </div>
                        <div class="itemForm">
                            <div class="label">总匹配数据：</div>
                            <div class="value">
                                <div>{{mappingList.length}}</div>
                            </div>
                        </div>
                        <div class="itemForm">
                            <div class="label">已匹配数据：</div>
                            <div class="value">
                                <div>{{noNum}}</div>
                            </div>
                        </div>
                        <div class="itemForm">
                            <div class="label">目标字段：</div>
                            <div class="value">
                                <div>{{mappingTypeList.length}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="importMapping">
                        <el-button type="primary" class="btn" size="small" @click="getMappingHistory">字段映射</el-button>
                    </div>
                    <div class="mapping">
                        <div class="mappingList">
                            <div class="mappingHeander">
                                <div class="mappingItem">
                                    <div class="mappingName">源字段</div>
                                    <div class="mappingValue">目标字段</div>
                                    <div class="mappingValue">字段名</div>
                                </div>
                            </div>
                            <div class="mappingBody">
                                <div class="mappingItem"  v-for="item in mappingList" :key="item.originalField">
                                    <div class="mappingName">{{item.originalField}}</div>
                                    <div class="mappingValue">
                                        <el-select v-model="item.mappedField" clearable value-key="mappedField" size="small" placeholder="请选择">
                                            <el-option
                                                    v-for="item in mappingTypeList"
                                                    :label="item.mappedFieldName"
                                                    :value="item.mappedField"
                                                    :key="item.mappedField"
                                            ></el-option>
                                        </el-select>
                                    </div>
                                    <div class="mappingValue">
                                        <el-tag v-if="item.mappedField">{{item.mappedField}}</el-tag>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="stepsBtns">
                        <el-button class="btn" size="small" @click="prevStep">上一步</el-button>
                        <el-button type="primary" class="btn" size="small" @click="nextStep">下一步</el-button>
                    </div>
                </div>
<!--                <div class="stepsItem" v-if="stepActive===3">-->
<!--                    <div class="itemForm">-->
<!--                        <div class="label">-->
<!--                            数据所属城市:-->
<!--                        </div>-->
<!--                        <div class="value">-->
<!--                            <el-cascader-->
<!--                                    v-model="city"-->
<!--                                    :options="cityList"-->
<!--                                    :props="{-->
<!--                                        multiple: false,-->
<!--                                        label:'lable',-->
<!--                                        value:'lable'-->
<!--                                    }"-->
<!--                                    size="small"-->
<!--                                    clearable-->
<!--                            ></el-cascader>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="itemForm">-->
<!--                        <div class="label">-->
<!--                            数据单位:-->
<!--                        </div>-->
<!--                        <div class="value">-->
<!--                            <el-select v-model="unit" size="small" placeholder="请选择" value-key="mapperId">-->
<!--                                <el-option label="ppb" value="ppb"></el-option>-->
<!--                                <el-option label="ug/m3" value="ug/m3"></el-option>-->
<!--                            </el-select>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="stepsBtns">-->
<!--                        <el-button class="btn" size="small" @click="prevStep">上一步</el-button>-->
<!--                        <el-button type="primary" class="btn" size="small" @click="nextStep">下一步</el-button>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="stepsItem" v-if="stepActive===3">
                    <div class="stepsBtns">
                        <el-button class="btn" size="small" @click="prevStep">上一步</el-button>
                        <el-button type="primary" class="btn" size="small" @click="nextStep">确定导入</el-button>
                    </div>
                </div>
            </div>
        </div>


        <el-dialog
                title="保存映射关系"
                :visible.sync="dialogVisible"
                :before-close="handleClose">
            <el-form ref="form" :model="form" :rules="rules" label-width="80px" size="small">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="名称" prop="name">
                            <el-input v-model="form.name" placeholder="建议输入格式 2024/01/01-2024/03/01 - 4个站点 "/>
                        </el-form-item>
                        <el-form-item label="备注" prop="remark">
                            <el-input v-model="form.remark" placeholder="建议输入格式 数据来源-项目来源"/>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="saveMapping">确 定</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog
                title="映射记录"
                :visible.sync="mappingVisible"
                :before-close="handleMHClose">
            <div class="dialogMapping" >

                <div class="mappingForm">
                    <div class="itemForm">
                        <div class="label">
                            名称:
                        </div>
                        <div class="value">
                            <el-input size="small" v-model="mappingHForm.name" placeholder="输入名称 "/>

                        </div>
                    </div>
                    <div class="itemForm">
                        <div class="label">
                            城市:
                        </div>
                        <div class="value">
                            <el-cascader
                                    v-model="mappingHForm.citys"
                                    :options="cityList"
                                    :props="{
                                        multiple: false,
                                        label:'lable',
                                        value:'lable'
                                    }"
                                    size="small"
                                    clearable
                            ></el-cascader>
                        </div>
                    </div>
                    <div class="stepsBtns">
                        <el-button type="primary" class="btn" size="small" @click="getMappingHistory">查询</el-button>
                    </div>
                </div>

                <el-table
                        :data="mappingHData.list"
                        size="small"
                        style="width: 100%">
                    <el-table-column
                            prop="name"
                            label="名称"
                            show-overflow-tooltip
                            width="280">
                    </el-table-column>
                    <el-table-column
                            prop="city"
                            show-overflow-tooltip
                            label="城市"
                          >
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            show-overflow-tooltip
                            label="备注">
                    </el-table-column>
                    <el-table-column
                            label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="getMappingInfo(scope.row)">导入</el-button>
                        </template>
                    </el-table-column>
                </el-table>


                <pagination
                        v-show="mappingHData.totalCount>mappingHForm.pageSize"
                        :total="mappingHData.totalCount"
                        :page.sync="mappingHForm.page"
                        :limit.sync="mappingHForm.pageSize"
                        @pagination="getMappingHistory"
                />
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="autoMapping">自动匹配</el-button>
                <el-button @click="mappingVisible = false" size="small">退 出</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>

    import url from "../../../utils/UrlApi"
    import Breadcrumb from "../../../components/breadcrumb";
    import XLSX from 'xlsx'
    import {getToken} from '@/utils/auth'

    export default {
        name: "index",
        components: {Breadcrumb},
        data() {
            return {
                stepId:'', //
                stepActive:0,
                stepsForm:{
                    unit:'',
                },

                uploadExcel: url.mapperOperationupload,
                headers: {
                    Authorization: getToken()
                },

                fileList:[],
                fileSheetList:[],

                selectSheet:[],

                typeList:[],
                mappingList:[],
                mappingTypeList:[],

                cityList:[],
                citys:'',
                unit:'',

                dialogVisible:false,
                form:{},
                rules: {
                    name: [
                        {required: true, message: "名称不能为空", trigger: "blur"}
                    ],
                    // citys: [
                    //     {required: true, message: "请选择城市", trigger: "change"}
                    // ],
                },


                mappingVisible:false,
                mappingHData:{
                    totalCount:0
                },
                mappingHForm:{
                    page:1,
                    pageSize:10,
                    name:''
                },
            }
        },
        computed: {
            noNum() {
                let num =0
                this.mappingList.forEach(item=>{
                    if (item.mappedField){
                        num++
                    }
                });
                return num
            },
            total() {
                return this.mappingList.length;
            },
            paginatedList() {
                const start = (this.currentPage - 1) * this.pageSize;
                const end = start + this.pageSize;
                return this.mappingList.slice(start, end);
            }
        },
        mounted(){
          this.getstep()
          this.getDataType()
            this.getCityList()
        },
        methods: {

            // 初始化数据
            initData(){
                this.stepActive = 0
                this.stepId = ''
                this.stepsForm = {
                    unit:"",
                }
                this.fileSheetList = []
                this.fileList=[]
                this.fileSheetList=[]
                this.selectSheet=[]

                this.mappingList=[]
                this.mappingTypeList=[]
                this.city=''

            },
            getCityList() {
                let data = {}
                this.$http.get(url.addressAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.cityList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getstep(){
                let data = {}
                this.$http.get(url.mapperOperationexist, { params: data}).then(res => {
                    if (res.data.code === '200') {
                        console.log(res)
                        if(res.data.data){
                            this.stepsForm = res.data.data

                            this.stepId =res.data.data.id

                            switch (res.data.data.currentStep) {
                                case "stepSelect" :
                                    this.stepActive = 1
                                    break;
                                case "stepFileUpload" :
                                    this.stepActive = 2
                                    this.citys = res.data.data.citys

                                    this.fileList = [{name:res.data.data.fileUpload.fileName}]
                                    this.fileSheetList = res.data.data.fileUpload.sheets.allSheet
                                    this.selectSheet = res.data.data.fileUpload.sheets.selectSheet
                                    this.getMappingHistory()
                                    this.getmappingList()
                                    break;
                                case "stepFieldMapping" :
                                    this.stepActive = 3
                                    this.citys = res.data.data.citys

                                    this.mappingList =  res.data.data.fieldMapping
                                    this.getmappingList()
                                    this.fileList = [{name:res.data.data.fileUpload.fileName}]
                                    this.fileSheetList = res.data.data.fileUpload.sheets.allSheet
                                    this.selectSheet = res.data.data.fileUpload.sheets.selectSheet
                                    break;
                            }

                        }else {
                           this.initData()
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            setOneStep(){

                if(!this.stepsForm.mapperTable){
                    this.$message.error('请选择数据类型')
                    return
                }

                if(!this.stepsForm.citys || !this.stepsForm.citys.length){
                    this.$message.error('请选择城市')
                    return
                }



                let data = {
                    currentStep:'stepSelect',
                    id:this.stepId,
                    mapperTable:this.stepsForm.mapperTable,
                    citys:this.stepsForm.citys,
                    unit:this.stepsForm.unit
                }
                const loading = this.$loading({
                    lock: true,
                    text: '处理中...',
                    spinner: 'el-icon-loading',
                });
                this.$http.post(url.mapperOperationstep, data).then(res => {
                    loading.close()
                    if (res.data.code === '200') {
                        this.stepActive = 1
                        this.getstep()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            setTwoStep(){


                let data = {
                    currentStep:'stepFileUpload',
                    id:this.stepId,
                    fileUpload:this.stepsForm.fileUpload
                }
                const loading = this.$loading({
                    lock: true,
                    text: '处理中...',
                    spinner: 'el-icon-loading',
                });
                this.$http.post(url.mapperOperationstep, data).then(res => {
                    loading.close()
                    if (res.data.code === '200') {
                        this.stepActive = 2
                        this.getMappingHistory()
                        this.getmappingList()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            setThreeStep(){

                if(!this.mappingList.length){
                    this.$message.error('请进行字段映射')
                    return
                }else {

                    let station = false
                    let time_point = false

                    this.mappingList.forEach(item=>{
                        if(item.mappedField==='station'){
                            station = true
                        }
                        if(item.mappedField==='time_point'){
                            time_point = true
                        }
                    })


                    if(!station){
                        this.$message.error('映射字段中必须含有站点字段,请检查')
                        return
                    }

                    if(!time_point){
                        this.$message.error('映射字段中必须含有时间字段,请检查')
                        return
                    }


                }


                let data = {
                    currentStep:'stepFieldMapping',
                    id:this.stepId,
                    fieldMapping:this.mappingList
                }
                const loading = this.$loading({
                    lock: true,
                    text: '处理中...',
                    spinner: 'el-icon-loading',
                });
                this.$http.post(url.mapperOperationstep, data).then(res => {
                    loading.close()
                    if (res.data.code === '200') {
                        this.$confirm('是否需要将本次映射关系保存?', '提示', {
                            confirmButtonText: '保存',
                            cancelButtonText: '不保存',
                            type: 'warning'
                        }).then(() => {
                            this.dialogVisible = true
                            // this.stepActive = 3
                        }).catch(() => {
                            this.stepActive = 3
                        });
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            setFourStep(cover){

                let self = this
                let data = {
                    currentStep:'stepImport',
                    id:this.stepId,
                    cover:cover,
                    importResult:{status:'success'}
                }
                const loading = this.$loading({
                    lock: true,
                    text: '处理中...',
                    spinner: 'el-icon-loading',
                });
                this.$http.post(url.mapperOperationstep, data).then(res => {
                    loading.close()
                    if (res.data.code === '200') {
                        this.initData()
                        this.$message.success('数据导入成功')
                    } else if (res.data.code === '404') {

                        this.$confirm(res.data.message, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            self.setFourStep(true)
                        }).catch(() => {
                        });

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },


            saveMapping(){
                let self = this

                this.$refs["form"].validate(valid => {
                    if (valid) {

                        let data = self.form
                        data.citys = this.stepsForm.citys
                        data.mapperId=self.stepsForm.mapperTable.mapperId
                        data.fieldMapping=this.mappingList
                        this.$http.post(url.mapperOperationcustomizeSet, data).then(res => {
                            if (res.data.code === '200') {
                                this.stepActive = 3
                                this.dialogVisible = false
                                this.$message.success('映射关系保存成功')
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                    }
                });
            },

            getDataType(){
                let data = {}
                this.$http.get(url.maperTablelist, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.typeList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            nextStep(){

                let self = this
                console.log(self.stepActive)
                switch (self.stepActive) {
                    case 0 :
                        this.setOneStep()
                        break;
                    case 1 :

                        if(this.fileList && this.fileList.length){
                            this.stepsForm.fileUpload={
                                fileName :this.fileList[0].name,
                                sheets:{
                                    allSheet : this.fileSheetList,
                                    selectSheet:this.selectSheet
                                }
                            }
                            this.setTwoStep()
                        }else {

                            if(this.selectSheet.length){
                                this.submitUpload()
                            }else {
                                this.$message.error('请上传文件并选择sheet')
                            }
                        }

                        this.mappingList = []

                        break;
                    case 2 :
                        this.setThreeStep()
                        break;
                    case 3 :
                        this.setFourStep()
                        break;

                }

                // this.stepActive +=1
            },

            prevStep(){
                this.stepActive -=1
            },


            getmapping(){
                let data = {id:this.stepId}
                this.mappingList = []
                const loading = this.$loading({
                    lock: true,
                    text: '处理数据中...',
                    spinner: 'el-icon-loading',
                });
                this.$http.get(url.mapperOperationmapping, {
                    params: data
                }).then(res => {
                    loading.close()
                    if (res.data.code === '200') {
                        this.mappingList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            getmappingList(){
                let data = {mapperId:this.stepsForm.mapperTable.mapperId}
                this.$http.get(url.mapperOperationmappingList, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.mappingTypeList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },


            getMappingHistory(){
                let data = {
                    mapperId:this.stepsForm.mapperTable.mapperId,
                    page:this.mappingHForm.page,
                    pageSize:this.mappingHForm.pageSize,
                    name:this.mappingHForm.name,
                    city:this.mappingHForm.citys ? this.mappingHForm.citys[1] : '' ,
                }

                this.$http.get(url.mapperOperationcustomizeList, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.mappingVisible = true
                        this.mappingHData = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            getMappingInfo(item){
                let data = {
                    id:this.stepId,
                    mapperCustomizeId:item.id}
                const loading = this.$loading({
                    lock: true,
                    text: '处理数据中...',
                    spinner: 'el-icon-loading',
                });
                this.$http.get(url.mapperOperationmapping, {
                    params: data
                }).then(res => {
                    loading.close()
                    if (res.data.code === '200') {
                        this.mappingVisible = false
                        this.mappingList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },


            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            handleRemove(){
                this.fileList = []
                this.fileSheetList=[]
                this.selectSheet=[]
            },
            handleChange(files, fileList) {

                // this.fileList = []

                let self = this
                var file =  files.raw;
                let sheetList= []  //
                let base64file = ''

                var reader = new FileReader();
                reader.readAsDataURL(file);
                //转base64
                reader.onload = function(e) {
                    let data  = e.target.result
                    base64file = data


                    let reader2 = new FileReader()
                    reader2.readAsBinaryString(file)
                    reader2.onload = ev => {
                        let dataBinary =  ev.target.result
                        let workBook = XLSX.read(dataBinary, {type: 'binary', cellDates: true})
                        for (var sheet in workBook.Sheets) {
                            if (workBook.Sheets.hasOwnProperty(sheet)) {
                                sheetList.push(sheet)
                            }
                        }

                        console.log(sheetList)

                        self.fileSheetList = sheetList

                    }

                }
            },
            fileSuccess(res, file) {
                // res为图片服务器返回的数据
                  // 如果上传成功
                if (res.code == 200) {
                    this.stepsForm.fileUpload={
                        fileName :res.data.fileName,
                        sheets:{
                            allSheet : this.fileSheetList,
                            selectSheet:this.selectSheet
                        }
                    }
                    this.fileList = [{name:res.data.fileName}]

                    this.setTwoStep()
                } else {
                    this.$message.error(res.message);
                }
            },
            submitUpload() {
                this.$refs.upload.submit();
            },

            autoMapping(){
                this.mappingVisible = false
                this.mappingList = []
                this.getmapping()
            },

            mapperTableChange(value){
                console.log(value)
                if(value.mapperId!==1){
                    this.stepsForm.unit = ''
                }else {
                    this.stepsForm.unit = 'ppb'
                }
            },

            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },


            handleMHClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {
                        this.mappingVisible = false
                    });
            }
        }
    }
</script>

<style scoped lang="less">
    .newPage {
        .content {
            /*display: flex;*/
            padding: 10px;
            height: calc(100vh - 200px);
            .steps{
                padding:  10px;
                /*height: 100%;*/
            }
            .stepsContent{
                min-width: 300px;
                padding: 0 20px;
                .stepsItem{
                    .mapForm{
                        display: flex;
                        .itemForm{
                            margin-right: 10px;
                        }
                    }
                    .itemForm{
                        display: flex;
                        align-items: center;
                        margin-bottom: 8px;
                        .label{
                            width: 140px;
                            color: #000;
                            font-size: 14px;
                        }
                        .value{}
                    }
                    .stepsBtns{
                        margin-top: 10px;
                        .btn{

                        }
                    }
                    .fileBox{
                        .fileList{
                            padding: 8px;
                            border-radius: 4px;
                            border: 1px solid #555;
                            .fileItem{
                                display: flex;
                                .fileName{
                                    width: 200px;
                                }
                            }
                        }
                        .fileAdd{
                            margin-top: 8px;
                        }
                    }
                    .sheetBox{
                        margin-top: 10px;
                        .sheetList{
                            padding: 8px;
                            border-radius: 4px;
                            border: 1px solid #555;
                        }
                    }
                    .mapping{
                        max-height: 650px; /* 设置最大高度 */
                        overflow-y: auto; /* 垂直滚动条 */

                        .mappingList{
                            margin-top: 10px;
                            .mappingHeander{
                                font-weight: bold;
                                font-size: 14px;
                                text-align: center;
                                padding-bottom: 10px;
                                border-bottom: 1px solid #ccc;
                            }
                            .mappingBody{
                                max-height: 500px;
                                overflow-y: auto;
                                width: 100%;
                                padding-top: 10px;
                                text-align: center;
                                .mappingItem{
                                    &:hover{
                                        background-color: #cdccc7;
                                    }
                                }
                            }
                            .mappingItem{
                                display: flex;
                                padding: 4px 0;

                                .mappingName{
                                    flex: 2;
                                }
                                .mappingValue{
                                    flex: 1;
                                }
                            }
                        }

                    }
                    .importMapping{
                        text-align: right;
                    }
                }
            }
        }
    }


    .dialogMapping{
        .mappingForm{
            display: flex;
            flex-wrap: wrap;
            .itemForm{
                display: flex;
                align-items: center;
                margin-bottom: 8px;
                .label{
                    width: 60px;
                    color: #000;
                    font-size: 14px;
                }
                .value{}
            }
            .stepsBtns{
                margin-left: 10px;
                .btn{

                }
            }
        }
    }

    /deep/ .el-upload-list{
        margin-top: 10px;
        min-height: 60px;
        padding: 0 8px;
        border-radius: 4px;
        border: 1px solid #555;
    }

    /deep/ .el-upload__tip{
      color: red;
    }



</style>
